import { render } from "./software-services.vue?vue&type=template&id=3a149ff8"
import script from "./software-services.vue?vue&type=script&lang=js"
export * from "./software-services.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Master\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__